"use strict";

exports.__esModule = true;
exports.default = exports.CardSection = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Card = _interopRequireDefault(require("./Card"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const propTypes = {
  tag: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string])
};
const defaultProps = {
  tag: 'div'
};
const CardSection = props => {
  const {
    tag: Tag,
    className,
    ...attributes
  } = props;
  const classes = (0, _clsx.default)('uk-card-section', className);
  return /*#__PURE__*/_react.default.createElement(Tag, _extends({
    className: classes
  }, attributes));
};
exports.CardSection = CardSection;
CardSection.propTypes = propTypes;
CardSection.defaultProps = defaultProps;
var _default = exports.default = CardSection;